<div class="w-full xl:px-4 md:px-2 xl:py-1 py-2 mb-3">
  @if (mediaSection === 'MEDIA') {
    <div class="flex justify-between gap-4 flex-wrap w-full items-center">
      <h4 class="text-xs font-sans font-medium">
        Media
      </h4>
      <!-- <button mat-stroked-button color="primary">2 - File Select</button> -->
    </div>
  }
  <div class="w-full pt-2 flex flex-wrap -m-2">
    @for (media of ($safeNavigationMigration($any(checklists)[itemInfo.formattedItemCode]?.[sectionkey]) | slice: 0:6); track media; let i = $index) {
      <div class="2xl:w-[14.28%] xl:w-1/6 lg:w-1/6 md:w-1/6 sm:w-1/6 min-w-32 w-full p-2">
        <div class="common-image-card-with-image-name cursor-pointer">
          <!-- Files -->
          @if (i < 5 || checklists[itemInfo.formattedItemCode]?.[sectionkey]?.length <= 6) {
            <div class="w-100 relative">
              @if (!isImageLoaded($any(media))) {
                <div class="img-loading-skeleton"></div>
              }
              <img class="card-image" [src]="getFileUrl($any(media))" alt="Media"
                [title]="isImageFile($any(media)) ? '' : $any(media).caption"
                role="button" tabindex="0"
                (click)="onFileTileClick($any(media), i)" (keydown.enter)="onFileTileClick($any(media), i)"
                (load)="markImageAsLoaded($any(media))" (error)="setDefaultImage($event)" />
                <div class="actions absolute flex items-center justify-center gap-2 top-2 right-2">
                  <div (click)="downloadFile($any(media))" title="Download"
                    role="button" tabindex="0" (keydown.enter)="downloadFile($any(media))"
                    class="bg-white h-[22px] w-[22px] flex items-center justify-center rounded-[4px] cursor-pointer">
                    <img src="../../../../../assets/icons/download.svg" width="13" alt="">
                  </div>
                  @if (!isDisabled && isImageFile($any(media))) {
                    <div (click)="openPinturaEditImageModal($any(media))" title="Edit"
                      role="button" tabindex="0" (keydown.enter)="openPinturaEditImageModal($any(media))"
                      class="delete-icon bg-white h-[22px] w-[22px] flex items-center justify-center rounded-[4px] cursor-pointer">
                      <img src="../../../../../assets/icons/edit.svg" width="13" alt="">
                    </div>
                  }
                  @if (!isDisabled) {
                    <div (click)="openDeleteImageModal($any(media), filePicker)" title="Delete"
                      role="button" tabindex="0" (keydown.enter)="openDeleteImageModal($any(media), filePicker)"
                      class="delete-icon bg-red h-[22px] w-[22px] flex items-center justify-center rounded-[4px] cursor-pointer">
                      <img src="../../../../../assets/icons/delete.svg" width="13" alt="">
                    </div>
                  }
                </div>
              </div>
            }
            <!-- More Files -->
            @if (i === 5 && checklists[itemInfo.formattedItemCode]?.[sectionkey]?.length > 6) {
              <div class="w-100 relative">
                <div class="card-image blur-[1px] dddd"></div>
                <div class="more-image-container" role="button" tabindex="0" (click)="openImageModal()" (keydown.enter)="openImageModal()">
                  <h4 class="text-white text-2xl font-medium">
                    +{{ (checklists[itemInfo.formattedItemCode]?.[sectionkey]?.length || 0) - 5 }}
                  </h4>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <!-- Upload New -->
      <div class="flex-none w-32 p-2">
        @if (!isDisabled && (mediaSection === 'ANS' || mediaSection === 'MEDIA_ANS')) {
          <div (click)="filePicker.click()" (keydown.enter)="filePicker.click()"
            role="button" tabindex="0"
            (dragover)="onDragOver($event)" (drop)="onDrop($event, filePicker)"
            class="common-image-card-with-image-name flex justify-center items-center relative border border-dashed border-primary rounded-md cursor-pointer">
            <img src="../../../../../assets/icons/add-image.svg" class="lg:w-11 md:w-8 h-28" alt="Upload" />
          </div>
        }
      </div>

      <input type="file" #filePicker multiple
            [attr.accept]="mediaSection === 'ANS'
                    ? '.jpeg,.jpg,.png,.bmp'
                    : mediaSection === 'MEDIA_ANS'
                    ? null
                    : '.jpeg,.jpg,.png,.bmp,.pdf,.txt,.csv,.xls,.xlsx,.doc,.docx'"
        style="display: none" (change)="selectFiles($event, filePicker)" [disabled]="isDisabled">
      </div>

    </div>